import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BiSolidContact } from "react-icons/bi";
import { AiOutlineClose } from "react-icons/ai";
import { FaLocationDot } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { GrInstagram } from "react-icons/gr";
import { FaLinkedinIn } from "react-icons/fa";
import { BsTwitterX } from "react-icons/bs";
import { FiMenu } from "react-icons/fi";
import { FaPhone } from "react-icons/fa6";
import { IoMdMail } from "react-icons/io";

import "./Header.css";
import logo from "../../assets/images/GUINEGULF LOGO WHITE.png";
import questionnaire from "../../assets/documents/GGE_KYC_QUESTIONNAIRE.docx";

function Header() {
  const navigate = useNavigate();
  const [menu, setMenu] = useState(false);
  const [dropdown, setDropdown] = useState(false);

  return (
    <div className="header">
      <section className="header__section__one">
        <div className="header__section__one__info">
          <a
            href="tel:+2347037593408"
            style={{
              textDecoration: "none",
              color: "var(--color-text-quanternary)",
              fontWeight: "600",
            }}
          >
            <p>
              CALL +2347037593408
              <FaPhone className="header__section__one__info__icon" />
            </p>
          </a>
          <p
            onClick={() =>
              (window.location =
                "mailto:info@guinegulfenergy.com?subject=Access request")
            }
          >
            info@guinegulfenergy.com
            <IoMdMail className="header__section__one__info__icon" />
          </p>
          <a
            href={questionnaire}
            download
            target="_blank"
            style={{
              textDecoration: "none",
              color: "var(--color-text-quanternary)",
              fontWeight: "600",
            }}
          >
            <p>Download KYC Questionnaire</p>
          </a>
        </div>
        <div className="header__section__one__socials">
          <p>en | </p>
          {/* <FaFacebookF className="header__section__one__socials__icons" />
          <GrInstagram className="header__section__one__socials__icons" />
          <FaLinkedinIn className="header__section__one__socials__icons" />
          <BsTwitterX className="header__section__one__socials__icons" /> */}
        </div>
      </section>

      <section className="header__section__two">
        <img
          src={logo}
          alt=""
          onClick={() => {
            navigate("/");
          }}
        />

        <ul className="header__section__navbar">
          <li
            onClick={() => {
              navigate("/about/glance");
            }}
          >
            About us
          </li>
          <li
            onClick={() => {
              navigate("/operations");
            }}
          >
            Operations
          </li>
          <li
            onClick={() => {
              navigate("/csr");
            }}
          >
            CSR
          </li>
          <li
            onClick={() => {
              navigate("/contact");
            }}
          >
            Contact
          </li>
        </ul>
        <FiMenu
          className="header__section__one__socials__icons"
          onClick={() => {
            setMenu(true);
          }}
        />
      </section>
      <div className={menu ? "home_sidebar_true" : "home_sidebar"}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            background: "var(--color-accent-secondary)",
            padding: "10px 10px",
          }}
        >
          <Link to="/">
            <img
              src={logo}
              className="evajay_header2"
              alt=""
              onClick={() => {
                navigate("/");
              }}
            />
          </Link>
          <AiOutlineClose
            className="home_sidebar_close"
            onClick={() => {
              setMenu(false);
            }}
          />
        </div>
        <ul className="home_sidebar_navbar">
          <li>
            <Link
              onClick={() => {
                setDropdown(!dropdown);
              }}
              to="#"
              className="home_sidebar_link"
            >
              About us
            </Link>
          </li>
          <div
            className={
              dropdown ? "header_dropdown_div" : "header_dropdown_div_false"
            }
          >
            <h1
              onClick={() => {
                navigate("/about/glance");
              }}
            >
              GuineGulf Energy at a glance
            </h1>
            <h1
              onClick={() => {
                navigate("/about/purpose");
              }}
            >
              Purpose and value
            </h1>
            <h1
              onClick={() => {
                navigate("/about/strategy");
              }}
            >
              Our strategy
            </h1>
          </div>
          <li>
            <Link to="/operations" className="home_sidebar_link">
              Operations
            </Link>
          </li>
          <li>
            <Link to="/csr" className="home_sidebar_link">
              CSR
            </Link>
          </li>
          <li>
            <Link to="/contact" className="home_sidebar_link">
              Contact
            </Link>
          </li>
          <li id="headerlist__section__one">
            <div>
              <span>
                <FaLocationDot id="headerlist__section__one__icon" />
                No. 4 Wharf Road, FOT Roundabout, OGFZE Onne, beside Sunway
                Hotel, Eleme, Rivers State, Nigeria.
              </span>
              <span>
                <IoMdMail id="headerlist__section__one__icon" />{" "}
                info@guinegulfenergy.com
              </span>
            </div>
            <div>
              <span>
                <BiSolidContact id="headerlist__section__one__icon" /> Contact
                Us
              </span>
              <span>
                <FaPhone id="headerlist__section__one__icon" /> +2347037593408
              </span>
            </div>
            <div>
              <a
                href={questionnaire}
                download
                target="_blank"
                style={{
                  textDecoration: "none",
                  color: "var(--color-accent-secondary)",
                  fontWeight: "600",
                  marginTop: "30px",
                  fontSize: "18px",
                  border: "1px solid var(--color-accent-secondary)",
                  padding: "10px 20px",
                  borderRadius: "5px",
                }}
              >
                <p>Download KYC Questionnaire</p>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Header;
